import { BodyText, Button, Divider, HeadingOneText, TextInput } from '@mint/ui';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CardsetterMark } from '@cardsetter/brand';
import { Link } from 'react-router-dom';
import { RedirectWithStatus } from '../redirect-with-status';
import { isLoggedIn } from '../../../selectors';
import { resetPasswordRequest } from '../../../actions';
import styled from 'styled-components';

const Main = styled.main`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;

  h1 {
    margin-bottom: 2rem;
  }

  a {
    display: block;
    text-align: center;
    font-size: 12px;
    text-decoration: none;
    color: rgba(0, 0, 0, 0.5);
  }
`;

const Form = styled.div`
  flex: 1;
  padding: 1rem 1rem 4rem;
  max-width: 400px;
  text-align: center;
`;

const ButtonWrapper = styled.div`
  text-align: center;
  margin-top: 1rem;
  margin-bottom: 3rem;
`;

const MarkWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 3rem;

  svg {
    font-size: 4rem;
    flex: 1;
  }
`;

export const AdminResetPasswordPage: React.FunctionComponent = (): React.ReactElement => {
  const [email, setEmail] = useState('');
  const [resetRequested, setResetRequested] = useState(false);

  const dispatch = useDispatch();
  const loggedIn = useSelector(isLoggedIn);

  if (loggedIn && typeof window !== 'undefined') {
    setTimeout(() => {
      (window as Window).location.href = '/';
    }, 2000);
  } else if (loggedIn) {
    return <RedirectWithStatus status={302} to="/?viewport=true" />;
  }

  return (
    <Main>
      <Form>
        <MarkWrapper>
          <CardsetterMark />
        </MarkWrapper>
        <HeadingOneText>Reset Password</HeadingOneText>
        {resetRequested ? (
          <BodyText>
            Please check your email. If an account for {email} exists, you will
            receive a password reset link in the next few minutes.
          </BodyText>
        ) : (
          <>
            <TextInput
              label="Email"
              value={email}
              onChange={(v): void => setEmail(v.target.value)}
            />
            <ButtonWrapper>
              <Button
                onClick={(): void => {
                  dispatch(resetPasswordRequest(email));
                  setResetRequested(true);
                }}
              >
                Reset Password
              </Button>
            </ButtonWrapper>
          </>
        )}
        <BodyText>
          <Link to="/admin/login">Back to Login</Link>
        </BodyText>
      </Form>
    </Main>
  );
};
